/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type UsernameContainer_comment = {
    readonly id: string;
    readonly author: {
        readonly username: string | null;
    } | null;
    readonly " $refType": "UsernameContainer_comment";
};
export type UsernameContainer_comment$data = UsernameContainer_comment;
export type UsernameContainer_comment$key = {
    readonly " $data"?: UsernameContainer_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"UsernameContainer_comment">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UsernameContainer_comment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "author",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "username",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Comment",
    "abstractKey": null
} as any);
(node as any).hash = 'b6bc3d19b4d2450bf92f5cf93345b01b';
export default node;
